export const PATHS = {
  base: "/",
  buy: "buy",
  sell: "sell",
  dealService: "deal-service",
  auth: "auth",
  myPersonal: "my/personal",
  myDeal: "my/deal",
  reitFacility: "reit-facility",
  tradeIn: "tradeIn",
  ransom: "ransom",
  estimateForRealtor: "estimate-for-realtor",
};

export const TILDA_PATHS = {
  itReit: {
    base: "https://itreit.ru/tradein",
    ransom: "https://itreit.ru/ransom",
    sell: "https://itreit.ru/sell",
    buy: "https://itreit.ru/buy",
    dealService: "https://itreit.ru/deal-service",
    estimate: "https://itreit.ru/estimate",
    tradeIn_IT_REIT: "https://itreit.ru/tradein",
    tradeIn: "https://itreit.ru/tradein",
    personalAccount: "https://itreit.ru/personal_account",
  },
  reitInvest: {
    base: "https://reit-invest.ru",
    personalAccount: "https://reit-invest.ru/personal_account",
    reitFacility: "https://reit-invest.ru/sale",
    tradeIn: "https://reit-invest.ru/tradein",
    ransom: "https://reit-invest.ru/ransom",
    estimate: "https://reit-invest.ru/grade",
    buy: "https://reit-invest.ru/bu",
    sell: "https://reit-invest.ru/sa",
  },
};
